import moment from "moment";

 function addoneHourToTime(IOStime) {
    // Parse the date string
    let date = moment(IOStime);

    // Add one hour
    date.add(0, 'hour');

    // Format the date to hh:mm:ss
    return date.format('HH:mm:ss');
  }

  export default addoneHourToTime